export default {
  items: [
    {
      id: "pages",
      title: "",
      type: "group",
      icon: "icon-pages",
      children: [
        {
          id: "menu-emissao",
          title: "VENDA",
          type: "collapse",
          icon: "fas fa-shopping-basket",
          children: [
            {
              id: "venda-sec-emitir",
              title: "Emitir",
              type: "section",
              icon: "emitir",
            },
            {
              id: "pdv",
              title: "PDV",
              type: "item",
              url: "/pdv/novo",
              classes: "nav-item",
              icon: "fas fa-shopping-cart",
              target: "true",
              external: "true",
            },
            {
              id: "nfe",
              title: "NFE",
              type: "item",
              url: "/nfe/novo",
              classes: "nav-item",
              icon: "fas fa-receipt",
              target: "true",
              external: "true",
            },
            {
              id: "orcamento-novo",
              title: "ORÇAMENTO",
              type: "item",
              url: "/vendas/orcamento/novo",
              classes: "nav-item",
              icon: "fas fa-file-invoice-dollar",
              target: "true",
              external: "true",
            },
            {
              id: "condicional-novo",
              title: "CONDICIONAL",
              type: "item",
              url: "/vendas/condicional/novo",
              classes: "nav-item",
              icon: "fas fa-shopping-bag",
              target: "true",
              external: "true",
            },
            {
              id: "venda-sec-gerenciar",
              title: "Gerenciar",
              type: "section",
              icon: "gerenciar",
            },
            {
              id: "gerenciar-auxiliar-venda",
              title: "AUXILIARES DE VENDA",
              type: "item",
              url: "/auxiliar-venda",
              classes: "nav-item",
              icon: "fas fa-file-contract",
            },
            {
              id: "gerenciar-nfce",
              title: "NFC-E",
              type: "item",
              url: "/nfce",
              classes: "nav-item",
              icon: "fas fa-file-contract",
            },
            {
              id: "gerenciar-nfe",
              title: "NFE",
              type: "item",
              url: "/nfe",
              classes: "nav-item",
              icon: "fas fa-file-contract",
            },
            {
              id: "gerenciar-orcamento",
              title: "ORÇAMENTOS",
              type: "item",
              url: "/vendas/orcamento",
              classes: "nav-item",
              icon: "fas fa-clipboard-list",
            },
            {
              id: "gerenciar-condicional",
              title: "CONDICIONAIS",
              type: "item",
              url: "/vendas/condicional",
              classes: "nav-item",
              icon: "fas fa-shopping-bag",
            },
          ],
        },
        {
          id: "menu-servicos",
          title: "SERVIÇOS",
          type: "collapse",
          icon: "fas fa-tools",
          children: [
            {
              id: "servico-sec-emitir",
              title: "Emitir",
              type: "section",
              icon: "emitir",
            },
            {
              id: "nfse",
              title: "NFS-E",
              type: "item",
              url: "/nfse/novo",
              classes: "nav-item",
              icon: "fas fa-file-invoice",
              target: "true",
              external: "true",
            },
            {
              id: "emissao-auxiliar-servico",
              title: "AUXILIAR DE SERVIÇO",
              type: "item",
              url: "/servicos/auxiliar-servico/novo",
              classes: "nav-item",
              icon: "fas fa-file-signature",
              target: "true",
              external: "true",
            },
            {
              id: "emissao-ordem-servico",
              title: "ORDEM DE SERVIÇO",
              type: "item",
              url: "/servicos/ordem-servico/novo",
              classes: "nav-item",
              icon: "fas fa-file-signature",
              target: "true",
              external: "true",
            },
            {
              id: "servico-sec-gerenciar",
              title: "Gerenciar",
              type: "section",
              icon: "gerenciar",
            },
            {
              id: "gerenciar-nfse",
              title: "NFS-E",
              type: "item",
              url: "/nfse",
              classes: "nav-item",
              icon: "fas fa-file-invoice-dollar",
            },
            {
              id: "gerenciar-auxiliar-servico",
              title: "AUXILIAR DE SERVIÇO",
              type: "item",
              url: "/servicos/auxiliar-servico",
              classes: "nav-item",
              icon: "fas fa-clipboard-list",
            },
            {
              id: "gerenciar-ordem-servico",
              title: "ORDEM DE SERVIÇO",
              type: "item",
              url: "/servicos/ordem-servico",
              classes: "nav-item",
              icon: "fas fa-clipboard-list",
            },
            {
              id: "agenda",
              title: "AGENDA",
              type: "item",
              url: "/servicos/agenda",
              classes: "nav-item",
              icon: "fas fa-calendar-alt",
            },
          ],
        },
        {
          id: "menu-caixa",
          title: "CAIXA",
          type: "collapse",
          icon: "fas fa-cash-register",
          children: [
            {
              id: "gerenciar-caixa",
              title: "GERENCIAR CAIXAS",
              type: "item",
              url: "/caixa/gerenciar",
              classes: "nav-item",
              icon: "fas fa-exchange-alt",
            },
            {
              id: "movimentacoes-caixa",
              title: "MOVIMENTAÇÕES",
              type: "item",
              url: "/caixa/movimentacoes",
              classes: "nav-item",
              icon: "fas fa-list-alt",
            },
          ],
        },
        {
          id: "menu-financeiro",
          title: "FINANCEIRO",
          type: "collapse",
          icon: "fas fa-money-bill-wave",
          children: [
            {
              id: "dashboard-financeiro",
              title: "DASHBOARD",
              type: "item",
              url: "/financeiro/dashboard",
              classes: "nav-item",
              icon: "fas fa-chart-line",
            },
            {
              id: "fin-sec-contas",
              title: "Contas",
              type: "section",
            },
            {
              id: "contas-pagar",
              title: "CONTAS A PAGAR",
              type: "item",
              url: "/financeiro/contas-pagar",
              classes: "nav-item",
              icon: "fas fa-credit-card",
            },
            {
              id: "contas-receber",
              title: "CONTAS A RECEBER",
              type: "item",
              url: "/financeiro/contas-receber",
              classes: "nav-item",
              icon: "fas fa-hand-holding-usd",
            },
            {
              id: "crediario",
              title: "CREDIÁRIO",
              type: "item",
              url: "/financeiro/crediario",
              classes: "nav-item",
              icon: "fas fa-calendar-alt",
            },
            {
              id: "fin-sec-mov",
              title: "Movimentações",
              type: "section",
            },
            {
              id: "movimentacoes-bancarias",
              title: "MOVIMENTAÇÕES BANCÁRIAS",
              type: "item",
              url: "/financeiro/movimentacoes-bancarias",
              classes: "nav-item",
              icon: "fas fa-university",
            },
          ],
        },
        {
          id: "menu-estoque",
          title: "ESTOQUE",
          type: "collapse",
          icon: "fas fa-archive",
          children: [
            {
              id: "dashboard-estoque",
              title: "DASHBOARD",
              type: "item",
              url: "/estoque/dashboard",
              classes: "nav-item",
              icon: "fas fa-chart-pie",
            },
            {
              id: "est-sec-estoque",
              title: "Estoque",
              type: "section",
            },
            {
              id: "gerenciar-estoque",
              title: "GERENCIAR ESTOQUE",
              type: "item",
              url: "/estoque/gerenciar",
              classes: "nav-item",
              icon: "fas fa-boxes",
            },
            {
              id: "notas-importadas",
              title: "NOTAS IMPORTADAS",
              type: "item",
              url: "/estoque/notas-importadas",
              classes: "nav-item",
              icon: "fas fa-file-invoice",
            },
          ],
        },
        {
          id: "menu-level",
          title: "CADASTROS",
          type: "collapse",
          icon: "fas fa-file-alt",
          children: [
            {
              id: "produto_level",
              title: "PRODUTOS",
              type: "collapse",
              icon: "fas fa-box",
              children: [
                {
                  id: "prod-sec-cadastro",
                  title: "Cadastro",
                  type: "section",
                },
                {
                  id: "produtos",
                  title: "PRODUTO",
                  type: "item",
                  url: "/cadastros/produtos",
                  classes: "nav-item",
                  icon: "fas fa-box",
                },
                {
                  id: "marcas",
                  title: "MARCAS",
                  type: "item",
                  url: "/cadastros/marcas",
                  classes: "nav-item",
                  icon: "fa fa-hashtag",
                },
                {
                  id: "categorias",
                  title: "CATEGORIAS",
                  type: "item",
                  url: "/cadastros/categorias",
                  classes: "nav-item",
                  icon: "fas fa-sitemap",
                },
                {
                  id: "prod-sec-auxiliares",
                  title: "Auxiliares",
                  type: "section",
                },
                {
                  id: "tabelaPreco",
                  title: "TABELA DE PREÇOS",
                  type: "item",
                  url: "/cadastros/tabela_preco",
                  classes: "nav-item",
                  icon: "fas fa-dollar-sign",
                },
                {
                  id: "unidades_medida",
                  title: "UNIDADES DE MEDIDA",
                  type: "item",
                  url: "/cadastros/unidades_medida",
                  classes: "nav-item",
                  icon: "fas fa-balance-scale",
                },
                {
                  id: "especieVolume",
                  title: "UNIDADES DE VOLUME",
                  type: "item",
                  url: "/cadastros/unidades_volume",
                  classes: "nav-item",
                  icon: "fas fa-boxes",
                },
              ],
            },
            {
              id: "servicos_level",
              title: "SERVIÇOS",
              type: "collapse",
              icon: "fas fa-concierge-bell",
              children: [
                {
                  id: "equipamentos",
                  title: "EQUIPAMENTOS/VEÍCULOS",
                  type: "item",
                  url: "/cadastros/equipamentos",
                  classes: "nav-item",
                  icon: "fas fa-tools",
                },
                {
                  id: "servicos",
                  title: "SERVIÇOS",
                  type: "item",
                  url: "/cadastros/servicos",
                  classes: "nav-item",
                  icon: "fas fa-concierge-bell",
                },
                {
                  id: "situacoes",
                  title: "SITUAÇÕES",
                  type: "item",
                  url: "/cadastros/situacoes",
                  classes: "nav-item",
                  icon: "fas fa-clipboard-list",
                },
              ],
            },
            {
              id: "pessoas_level",
              title: "PESSOAS",
              type: "collapse",
              icon: "fas fa-users",
              children: [
                {
                  id: "clientes",
                  title: "CLIENTES/FORNECEDORES",
                  type: "item",
                  url: "/cadastros/clientes",
                  classes: "nav-item",
                  icon: "fas fa-users",
                },
                {
                  id: "funcionarios",
                  title: "FUNCIONÁRIOS",
                  type: "item",
                  url: "/cadastros/funcionarios",
                  classes: "nav-item",
                  icon: "fa fa-id-badge",
                },
              ],
            },
            {
              id: "tributacao_level",
              title: "TRIBUTAÇÃO",
              type: "collapse",
              icon: "fas fa-vials",
              children: [
                {
                  id: "tributacaoPorNCM",
                  title: "TRIBUTAÇÃO POR NCM",
                  type: "item",
                  url: "/cadastros/tributacao_por_ncm",
                  classes: "nav-item",
                  icon: "fas fa-vials",
                },
                {
                  id: "tributacaoPorProduto",
                  title: "TRIBUTAÇÃO POR PRODUTO",
                  type: "item",
                  url: "/cadastros/tributacao_por_produto",
                  classes: "nav-item",
                  icon: "fas fa-vial",
                },
                {
                  id: "parametroNBS",
                  title: "PARÂMETROS NBS",
                  type: "item",
                  url: "/cadastros/parametro_nbs",
                  classes: "nav-item",
                  icon: "fas fa-list-alt",
                },
              ],
            },
            {
              id: "transportadora_level",
              title: "TRANSPORTE",
              type: "collapse",
              icon: "fas fa-dolly",
              children: [
                {
                  id: "transportadoras",
                  title: "TRANSPORTADORAS",
                  type: "item",
                  url: "/cadastros/transportadoras",
                  classes: "nav-item",
                  icon: "fas fa-dolly",
                },
                {
                  id: "veiculos",
                  title: "VEÍCULOS",
                  type: "item",
                  url: "/cadastros/veiculos",
                  classes: "nav-item",
                  icon: "fas fa-truck-moving",
                },
              ],
            },
            {
              id: "sistema_level",
              title: "SISTEMA",
              type: "collapse",
              icon: "fas fa-cogs",
              children: [
                {
                  id: "usuarios",
                  title: "USUÁRIOS",
                  type: "item",
                  url: "/cadastros/usuarios",
                  classes: "nav-item",
                  icon: "fas fa-user-tie",
                },
                {
                  id: "sis-sec-empresa",
                  title: "Empresa",
                  type: "section",
                },
                {
                  id: "empresas",
                  title: "EMPRESAS",
                  type: "item",
                  url: "/cadastros/empresas",
                  classes: "nav-item",
                  icon: "fas fa-store",
                },
                {
                  id: "contador",
                  title: "CONTADOR",
                  type: "item",
                  url: "/cadastros/contadores",
                  classes: "nav-item",
                  icon: "fas fa-calculator",
                },
                {
                  id: "certificados",
                  title: "CERTIFICADO DIGITAL",
                  type: "item",
                  url: "/cadastros/certificados",
                  classes: "nav-item",
                  icon: "fas fa-clipboard",
                },
                {
                  id: "sis-sec-financeiro",
                  title: "Financeiro",
                  type: "section",
                },
                {
                  id: "plano-contas",
                  title: "PLANO DE CONTAS",
                  type: "item",
                  url: "/cadastros/plano-contas",
                  classes: "nav-item",
                  icon: "fas fa-chart-pie",
                },
                {
                  id: "maquinas-cartao",
                  title: "MÁQUINAS DE CARTÃO",
                  type: "item",
                  url: "/cadastros/maquinas-cartao",
                  classes: "nav-item",
                  icon: "fas fa-credit-card",
                },
                {
                  id: "balancas",
                  title: "BALANÇAS",
                  type: "item",
                  url: "/cadastros/balancas",
                  classes: "nav-item",
                  icon: "fas fa-balance-scale",
                },
                {
                  id: "contas",
                  title: "CONTA",
                  type: "item",
                  url: "/cadastros/contas",
                  classes: "nav-item",
                  icon: "fas fa-university",
                },
                {
                  id: "bancos",
                  title: "BANCOS",
                  type: "item",
                  url: "/cadastros/bancos",
                  classes: "nav-item",
                  icon: "fas fa-landmark",
                },
              ],
            },
          ],
        },
        {
          id: "menu-parametrizacoes",
          title: "PARAMETRIZAÇÕES",
          type: "collapse",
          icon: "fas fa-sliders-h",
          children: [
            {
              id: "param-sec-parametros",
              title: "Parâmetros",
              type: "section",
            },
            {
              id: "parametros",
              title: "PARÂMETROS",
              type: "item",
              url: "/parametros",
              classes: "nav-item",
              icon: "fas fa-suitcase",
            },
            {
              id: "parametros_nfse",
              title: "PARÂMETROS DE IMPOSTOS NFS-E",
              type: "item",
              url: "/parametros_nfse",
              classes: "nav-item",
              icon: "fas fa-receipt",
            },
            {
              id: "preferencias_email",
              title: "PARAMÊTROS DE EMAIL",
              type: "item",
              url: "/parametros_email",
              classes: "nav-item",
              icon: "fas fa-envelope-square",
            },
            {
              id: "parametros_backup",
              title: "PARAMÊTROS DE BACKUP",
              type: "item",
              url: "/parametros_backup",
              classes: "nav-item",
              icon: "fas fa-database",
            },
            {
              id: "parametros_impressao",
              title: "PARÂMETROS DE IMPRESSÃO",
              type: "item",
              url: "/parametros_impressao",
              classes: "nav-item",
              icon: "fas fa-print",
            },
            {
              id: "param-sec-geral",
              title: "Geral",
              type: "section",
            },
            {
              id: "preferencias",
              title: "PREFERÊNCIAS",
              type: "item",
              url: "/preferencias",
              classes: "nav-item",
              icon: "fas fa-briefcase",
            },
            {
              id: "papeis",
              title: "PAPÉIS",
              type: "item",
              url: "/papeis",
              classes: "nav-item",
              icon: "fas fa-user-tag",
            },
            {
              id: "menu-backup",
              title: "BACKUP",
              type: "collapse",
              icon: "fas fa-cloud-upload-alt",
              children: [
                {
                  id: "backup_documentos_fiscais",
                  title: "DOCUMENTOS FISCAIS",
                  type: "item",
                  url: "/backup_documentos_fiscais",
                  classes: "nav-item",
                  icon: "fas fa-database",
                },
                {
                  id: "historico_documentos_fiscais",
                  title: "HISTÓRICO",
                  type: "item",
                  url: "/historico_backups",
                  classes: "nav-item",
                  icon: "fas fa-history",
                },
              ],
            },
          ],
        },
        {
          id: "menu-relatorios-etiquetas",
          title: "IMPRESSÕES",
          type: "collapse",
          icon: "fas fa-chart-bar",
          children: [
            {
              id: "relatorios",
              title: "RELATÓRIOS",
              type: "item",
              url: "/relatorios",
              classes: "nav-item",
              icon: "fas fa-chart-bar",
            },
            {
              id: "etiquetas",
              title: "ETIQUETAS",
              type: "item",
              url: "/etiquetas",
              classes: "nav-item",
              icon: "fas fa-tag",
            },
          ],
        },
      ],
    },
  ],
};
